import { render, staticRenderFns } from "./StudentsActions.vue?vue&type=template&id=c3a3a782&scoped=true"
import script from "./StudentsActions.vue?vue&type=script&lang=js"
export * from "./StudentsActions.vue?vue&type=script&lang=js"
import style0 from "./StudentsActions.vue?vue&type=style&index=0&id=c3a3a782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a3a782",
  null
  
)

export default component.exports